



















import { defineComponent, ref, computed } from '@vue/composition-api';
import ViewContainer from '../components/ViewContainer.vue';

export default defineComponent({
  name: 'Menu',
  components: {
    ViewContainer,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // eslint-disable-next-line
      (vm as any).prevRoute = from.path;
    });
  },
  setup(props, ctx) {
    const isWeb = computed(() => !!process.env.VUE_APP_WEB);
    const prevRoute = ref('');

    function openLink(url) {
      // window.open(url, '_self');
    }

    function goTo(route) {
      if (route === prevRoute.value) {
        ctx.root.$router.back();
      } else {
        ctx.root.$router.replace(route);
      }
    }

    return {
      isWeb,
      prevRoute,
      openLink,
      goTo,
    };
  },
});
